export const TOKEN_KEY = "@blitzar.token";
export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null;
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const login = token => {
  localStorage.setItem(TOKEN_KEY, token);
};
export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
};

export const isLogged = function () {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) return false;

  return token.length > 0;
}